export const productCodes = [
  'FOAP',
  'FOFRI',
  'FOHAND',
  'FOHLMB',
  'FONTB',
  'FOSVD',
  'FOTT',
  'FORBA0',
  'FOEKOTT',
  'FOINRTT',
  'FOKULTT',
  'FOKUNTT',
  'FOPOLTT',
  'FOSPTTT',
  'FOSPTSPC',
  'GRINRP',
  'GRINRW',
  'GRKULP',
  'GRKULW',
  'GRUTRP',
  'GRUTRW',
  'GRSPTP',
  'GRSPTW'
]
